import { getIsGretaAIChatProjectsEnabled } from '../../../GretaAIChat.utils.projects'
import { useGretaAIChatProjectActions } from '../../useGretaAIChatProjectActions'
import { useGretaAIChatProjects } from '../../useGretaAIChatProjects'

export function useGretaAIChatSessionProjects({
  activeChatIdRef,
  chats,
  isLocked,
  isOpen,
  openNewChat,
  panelRef,
}) {
  const projects = useGretaAIChatProjects({
    chats,
    isOpen: getIsGretaAIChatProjectsEnabled() && isOpen && !isLocked,
  })

  const { deleteProject, renameProject } = projects

  const {
    closeProjectAction,
    confirmDeleteProject,
    confirmRenameProject,
    openDeleteProject,
    openRenameProject,
    projectAction,
  } = useGretaAIChatProjectActions({
    activeChatIdRef,
    deleteProject,
    openNewChat,
    panelRef,
    renameProject,
  })

  return {
    projectAction,
    projectActions: {
      onCloseProjectAction: closeProjectAction,
      onConfirmDeleteProject: confirmDeleteProject,
      onConfirmRenameProject: confirmRenameProject,
      onDeleteProject: openDeleteProject,
      onRenameProject: openRenameProject,
    },
    projects,
  }
}
